
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5768',
  depVersions: {
  "data-privacy-request-ui": "static-1.5768",
  "client-types": "static-1.491",
  "data-fetching-client": "static-1.9907",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8277",
  "hub-http-shared-msw-handlers": "static-1.10529",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11733",
  "I18n": "static-7.1662",
  "jasmine-runner": "static-1.6699",
  "quartz": "static-1.7371",
  "react-dlb": "static-1.85",
  "rpc-client-utils": "static-1.4912",
  "ui-components-test-utils": "static-1.5870",
  "UIComponents": "static-3.8679",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.90",
  "foundations-assets": "static-1.5127",
  "foundations-components": "static-1.8391",
  "foundations-components-test-utils": "static-1.5874",
  "foundations-theming": "static-1.4707",
  "hub-http": "static-1.6463",
  "quartz-config": "static-1.1149",
  "quartz-core": "static-1.6590",
  "quartz-routing": "static-1.801",
  "quick-fetch": "static-1.4096",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-rhumb": "static-1.16960",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11395",
  "usage-tracker": "static-1.7606",
  "usage-tracker-anonymous": "static-1.6023",
  "usage-tracker-core": "static-1.7456",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3581",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3648",
  "quartz-webpack": "static-1.3595",
  "bend-plugin-quartz-routing": "static-1.449",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3388",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "ts-schema": "static-1.4258",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "react-utils": "static-2.5519",
  "StyleGuideUI": "static-3.495",
  "jasmine": "static-4.4568",
  "bend-plugin-chirp-manifest": "static-1.322",
  "chirp-fetch": "static-1.2141",
  "HubStyle": "static-2.12040",
  "ui-addon-draggable": "static-3.5006",
  "cssUtils": "static-1.871",
  "hs-story-utils": "static-1.9676",
  "icons": "static-2.674",
  "react-create-root-preference": "static-1.62",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1230",
  "bend-plugin-foundations-components": "static-1.4660",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2423",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2476",
  "ui-fonts": "static-1.995",
  "foundations-components-legacy": "static-1.1416",
  "bend-plugin-foundations-theming": "static-1.3190",
  "foundations-theming-base": "static-1.3692",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.258",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.869",
  "hubspotter-http": "static-1.4828",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1046",
  "quartz-head": "static-1.1036",
  "quartz-i18n": "static-1.1046",
  "quartz-test": "static-1.1046",
  "quartz-tracking": "static-1.750",
  "trellis-components": "static-1.2495",
  "usage-tracker-container": "static-1.7596",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3358",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.75",
  "sassPrefix": "static-1.161",
  "hubspotter-http-shared-msw-handlers": "static-1.10527",
  "usage-tracker-session-replay": "static-1.5292",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1212",
  "tanstack-virtual": "static-1.36",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5768",
  "client-types": "/client-types/static-1.491",
  "data-fetching-client": "/data-fetching-client/static-1.9907",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8277",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10529",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11733",
  "I18n": "/I18n/static-7.1662",
  "jasmine-runner": "/jasmine-runner/static-1.6699",
  "quartz": "/quartz/static-1.7371",
  "react-dlb": "/react-dlb/static-1.85",
  "rpc-client-utils": "/rpc-client-utils/static-1.4912",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5870",
  "UIComponents": "/UIComponents/static-3.8679",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "foundations-assets": "/foundations-assets/static-1.5127",
  "foundations-components": "/foundations-components/static-1.8391",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5874",
  "foundations-theming": "/foundations-theming/static-1.4707",
  "hub-http": "/hub-http/static-1.6463",
  "quartz-config": "/quartz-config/static-1.1149",
  "quartz-core": "/quartz-core/static-1.6590",
  "quartz-routing": "/quartz-routing/static-1.801",
  "quick-fetch": "/quick-fetch/static-1.4096",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-rhumb": "/react-rhumb/static-1.16960",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11395",
  "usage-tracker": "/usage-tracker/static-1.7606",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6023",
  "usage-tracker-core": "/usage-tracker-core/static-1.7456",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3581",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3648",
  "quartz-webpack": "/quartz-webpack/static-1.3595",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.449",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3388",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "ts-schema": "/ts-schema/static-1.4258",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "react-utils": "/react-utils/static-2.5519",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "jasmine": "/jasmine/static-4.4568",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.322",
  "chirp-fetch": "/chirp-fetch/static-1.2141",
  "HubStyle": "/HubStyle/static-2.12040",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5006",
  "cssUtils": "/cssUtils/static-1.871",
  "hs-story-utils": "/hs-story-utils/static-1.9676",
  "icons": "/icons/static-2.674",
  "react-create-root-preference": "/react-create-root-preference/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1230",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4660",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2423",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2476",
  "ui-fonts": "/ui-fonts/static-1.995",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1416",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3190",
  "foundations-theming-base": "/foundations-theming-base/static-1.3692",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.258",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.869",
  "hubspotter-http": "/hubspotter-http/static-1.4828",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1046",
  "quartz-head": "/quartz-head/static-1.1036",
  "quartz-i18n": "/quartz-i18n/static-1.1046",
  "quartz-test": "/quartz-test/static-1.1046",
  "quartz-tracking": "/quartz-tracking/static-1.750",
  "trellis-components": "/trellis-components/static-1.2495",
  "usage-tracker-container": "/usage-tracker-container/static-1.7596",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.75",
  "sassPrefix": "/sassPrefix/static-1.161",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10527",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5292",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1212",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
